import styled from 'styled-components';

export const UiBookFormPage = styled.div`
	display: flex;
	justify-content: center;
	padding: 10px;
`;
